import { set } from 'radash';
import { lazy, createSignal, createEffect, createResource, on } from 'solid-js';
import { Dynamic, template } from 'solid-js/web';

//const icons = import.meta.glob('./icons/*/*.svg', { as: 'component-solid' });
//console.log('Loading icons', icons);

const ICON_PATH = '/icons';

const emptyIcon = (props) => {
  //Empty icon with size props.size
  return <svg width={props.size} height={props.size}></svg>;
};

export const loadIcon = async ({ url, size, color }) => {
  let iconurl;
  if (!url)
    return window.URL.createObjectURL(
      new Blob([emptyIcon({ size })], { type: 'image/svg+xml' }),
    );
  try {
    iconurl = new URL(url);
  } catch (e) {
    console.log('Badly formed icon URL', url);
    return null;
  }
  if (iconurl.protocol != 'icon:') return url;
  let name = iconurl.hostname.replace(/\//g, '');
  const weight = iconurl.searchParams.get('weight') || 'regular';
  const icolor = iconurl.searchParams.get('color') || color || 'currentColor';
  if (weight != 'regular') name = name + '-' + weight;
  try {
    const icon = await fetch(`${ICON_PATH}/${weight}/${name}.svg`);
    let svg = await icon.text();
    svg = svg.replace(/currentColor/g, icolor);
    if (size)
      svg = svg.replace(/<svg/g, `<svg width="${size}" height="${size}"`);
    const blob = new Blob([svg], { type: 'image/svg+xml' });
    return window.URL.createObjectURL(blob);
  } catch {
    console.log('Icon not found', name);
    return null;
  }
};

export const Icon = (props) => {
  const [icon, setIcon] = createSignal(null);
  createEffect(() => {
    loadIcon(props).then(setIcon);
  });
  return <img src={icon()} />;
};
